<template>
  <el-card>
    <div slot="header" class="header">
      Create Customer
    </div>
      <el-steps :active="active" align-center>
        <el-step title="Customer">
        </el-step>
        <el-step title="Other Information">
        </el-step>
        <el-step title="Account" description="CRM">
        </el-step>
        <el-step title="Confirm" :status="status">
        </el-step>
      </el-steps>
    <transition name="el-fade-in-linear">
      <el-card v-show="active === 0">
        <el-form :model="form" ref="form" :rules="form0Rules">
          <el-form-item label="Email"
            prop="email"
            :error="formErrorMessage['email']"
            :rules="[
            { required: true, message: 'Please input email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address',
              trigger: ['blur', 'change'] }
            ]"
          >
            <el-input
              ref="email_input"
              v-model="form.email"
              required
              clearable
              @blur="() => checkUnique('email')"
              @clear="() => clearFormIcons('email')"
            >
              <i slot="suffix" :class="formIcons['email']"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="Company Name"
            prop="company"
            :rules="[
            { required: true, message: 'Please input company name', trigger: 'blur' },
            { type: 'string', message: 'Please input correct company name',
              trigger: ['blur', 'change'] }
            ]"
          >
            <el-input v-model="form.company" required clearable >
            </el-input>
          </el-form-item>
          <el-form-item label="Phone Number"
            prop="phone"
            :rules="[
              { required: true, message: 'Please input phone', trigger: 'blur' },
              { type: 'string', message: 'Please input correct phone',
                trigger: ['blur', 'change'] }
              ]"
          >
            <el-input v-model="form.phone" required clearable >
            </el-input>
          </el-form-item>
          <el-form-item label="Entity Type" prop="entity">
            <el-select v-model="form.entity" :style="{width: '100%'}">
              <el-option
                v-for="entity in entityOptions"
                :key="entity.value"
                :label="entity.label"
                :value="entity.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Organization State">
            <State
              isOrgStateInput
              :country="optional.country"
              :given-state="optional.orgState" @change="st => optional.orgState = st"
              size="large"
            />
          </el-form-item>
          <el-form-item label="Tax Exempted" prop="taxExempted">
            <el-switch
              v-model="form.taxExempted"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="True"
              inactive-text="False"
            ></el-switch>
          </el-form-item>
          <el-form-item
            label="Tax ID" prop="taxId"
            :error="formErrorMessage['taxId']"
          >
            <el-input v-model="form.taxId" @blur="() => checkUnique('taxId')" @clear="() => clearFormIcons('taxId')">
              <i slot="suffix" :class="formIcons['taxId']"></i>
            </el-input>
          </el-form-item>
          <el-button @click="next" :disabled="verifyingField">
            Next
          </el-button>
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card v-show="active === 1">
        <el-form :model="optional" ref="form2" :rules="form1Rules">
          <el-form-item label="Industry/Business">
            <el-select v-model="optional.business">
              <el-option :key="option" v-for="option of businessOptions" :value="option">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Use of Space">
            <el-select v-model="optional.subIndustry">
              <el-option :key="option" v-for="option of subIndustryOptions" :value="option">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Country">
            <el-select v-model="optional.country" @change="resetState">
              <el-option
                v-for="country in countries"
                :key="country.value"
                :label="country.label"
                :value="country.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
          label="Address Line 1"
          prop="address"
            :rules="[
            { type: 'string', message: 'Please input correct address',
              trigger: ['blur', 'change'] }
            ]"
          >
            <el-input v-model="form.address" size="small" clearable />
          </el-form-item>
          <el-form-item
          label="Address Line 2"
          prop="addres2"
            :rules="[
            { type: 'string', message: 'Please input correct address',
              trigger: ['blur', 'change'] }
            ]"
          >
            <el-input v-model="form.address2" size="small" clearable />
          </el-form-item>
          <el-form-item
          label="City"
          prop="city"
            :rules="[
            { type: 'string', message: 'Please input correct city',
              trigger: ['blur', 'change'] }
            ]"
          >
            <el-input v-model="form.city" size="small" clearable />
          </el-form-item>
          <el-form-item label="State"
            :rules="[
            { type: 'string', message: 'Please input correct state',
              trigger: ['blur', 'change'] }
            ]"
          >
            <State :country="optional.country" :given-state="optional.state" @change="st => optional.state = st"/>
          </el-form-item>
          <el-form-item label="Zip Code"
            prop="zip"
          >
            <el-input v-model="form.zip" size="small" clearable>
            </el-input>
          </el-form-item>
          <el-button @click="active -= 1" type="warning">
            Back
          </el-button>
          <el-button @click="next">
            Next
          </el-button>
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <el-card v-show="active === 2">
        <el-form v-model="primaryContact">
          <el-form-item label="Email">
            <el-input v-model="form.email" disabled></el-input>
          </el-form-item>
          <el-form-item label="Title">
            <el-input v-model="primaryContact.title"></el-input>
          </el-form-item>
          <el-form-item label="Firstname">
            <el-input v-model="primaryContact.firstName"></el-input>
          </el-form-item>
          <el-form-item label="Lastname">
            <el-input v-model="primaryContact.lastName"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="value">
            <el-input v-model="primaryContact.password" type="password">
              <el-button slot="prepend" @click="generateRandomCode">
                Generate random password
              </el-button>
              <el-button
                slot="append"
                icon="el-icon-copy-document"
                :disabled="!primaryContact.password"
                @click="copyText"
              ></el-button>
            </el-input>
          </el-form-item>
          <el-form-item v-if="isLevelOneUser" label="Temporary Password" prop="temporary">
            <el-checkbox v-model="primaryContact.temporary"></el-checkbox>
          </el-form-item>
          <el-button @click="active -= 1" type="warning">
            Back
          </el-button>
          <el-button @click="next">
            Next
          </el-button>
        </el-form>
      </el-card>
    </transition>
    <transition name="el-fade-in-linear">
      <CreateCustomerStepConfirm
        v-if="active === 3" :customer="customer"
        :primary-contact="primaryContact"
        @load="load"
      />
    </transition>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE, AUTH_API_BASE, CUSTOMER_API_BASE } from '../env';
import CreateCustomerStepConfirm from './CreateCustomerStepConfirm.vue';
import { countries } from '../utils/countries';
import State from './Sate.vue';
import randomCode from '../utils/random';

export default {
  name: 'CreateCustomerV2',
  components: { CreateCustomerStepConfirm, State },
  props: {
    facility: { type: String, default: null },
    newCustomer: { type: Object, default: null },
  },
  async mounted() {
    if (this.newCustomer) {
      const { email, company, salesforceId, business, subIndustry } = this.newCustomer;
      this.form.email = email;
      this.form.company = company;
      this.optional.business = business;
      this.optional.subIndustry = subIndustry;
      this.form.salesforceId = salesforceId;
      this.$refs.email_input.focus();
    }
  },
  computed: {
    verifyingField() {
      return this.verifying.email || this.verifying.taxId;
    },
    isLevelOneUser() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      return roles.includes('level_1');
    },
    status() {
      if (this.active < 3) {
        return 'wait';
      }

      if (this.customerAddedStatus) {
        return 'success';
      }

      return 'process';
    },
    customer() {
      return {
        ...this.form,
        userName: this.form.email,
        ...this.optional,
        primaryContact: {
          name: `${this.primaryContact.firstName} ${this.primaryContact.lastName}`,
          title: this.primaryContact.title,
          access: this.primaryContact.access,
          email: this.form.email,
        },
      };
    },
  },
  data() {
    const checkTaxId = (rule, value, callback) => {
      const regexp = /(^\d{9}$)|(^\d{3}-\d{2}-\d{4}$)|(^\d{3} \d{3} \d{3}$)|(^\d{2}-\d{7}$)|(^\d{2} \d{7}$)/;

      if (!value) {
        callback();
      }

      if (regexp.test(value)) { callback(); }

      callback(new Error('Invalid TaxID'));
    };

    return {
      countries,
      formFieldIsUnique: {
        email: true,
        taxId: true,
      },
      formIcons: {
        email: '',
        taxId: '',
      },
      formErrorMessage: {
        email: '',
        taxId: '',
      },
      verifying: {
        email: false,
        taxId: false,
      },
      entityOptions: [
        { label: 'Corporation', value: 'Corporation' },
        { label: 'Limited Liability Company', value: 'Limited Liability Company' },
        { label: 'Limited Liability Partnership', value: 'Limited Liability Partnership' },
        { label: 'Limited Partnership', value: 'Limited Partnership' },
        { label: 'Other', value: 'Other' },
        { label: 'Sole Proprietorship (Canada)', value: 'Sole Proprietorship (Canada)' },
        { label: 'Partnership (Canada)', value: 'Partnership (Canada)' },
        { label: 'Corporation (Canada)', value: 'Corporation (Canada)' },
        { label: 'Other (Canada)', value: 'Other (Canada)' }],
      businessOptions: [
        'Auto Repair / Maintenance',
        'Computers / Electronics',
        'Construction / Remodeling',
        'Construction Materials / Supplies',
        'Consumer Services',
        'eCommerce / Online Retail',
        'Grocery / Food Wholesale',
        'Home Staging',
        'Logistics',
        'Manufacturing',
        'Media / Entertainment',
        'Moving Company / Services',
        'Non-Profit',
        'Personal Storage',
        'Real Estate Agents / Appraiser',
        'Sports / Recreation',
        'Textiles / Apparel',
        'Warehousing / Commercial Storage',
        'Wholesale / Distribution',
      ],
      subIndustryOptions: [
        'Long Term / Dead storage',
        'Equipment / supplies storage',
        'eCommerce / Order fulfillment',
        '3PL / Transload',
        'General warehousing',
        'R&D / Prototyping / Testing',
        'Manufacturing',
        'Wholesale & Distribution',
        'Assembly',
        'Athletic Training',
        'Showroom / Retail',
        'Other',
      ],
      customerAddedStatus: false,
      active: 0,
      icons: [
        'el-icon-close red',
        'el-icon-check green',
        'el-icon-loading',
      ],
      form: {
        email: '',
        company: '',
        userName: '',
        phone: '',
        entity: '',
        taxExempted: false,
        taxId: '',
        salesforceId: '',
      },
      optional: {
        business: '',
        subIndustry: '',
        country: 'us',
        state: '',
        orgState: '',
      },
      primaryContact: {
        name: '',
        access: 'PRIMARY',
        title: '',
        firstName: '',
        lastName: '',
        password: '',
        generatedPassword: '',
        temporary: true,
      },
      form0Rules: {
        taxId: [
          { required: true, trigger: ['blur'] },
          { validator: checkTaxId, trigger: ['blur', 'change'] },
          {
            type: 'string',
            message: 'Please input correct Tax ID',
            trigger: ['blur', 'change'],
          },
        ],
      },
      form1Rules: {},
    };
  },
  methods: {
    load(status) {
      this.customerAddedStatus = true;
      this.$emit('load', status, this.active);
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.primaryContact.password);
        this.$message.success({
          title: 'Copied',
          message: 'Password copied to clipboard',
        });
      } catch (err) {
        this.$message.error({
          title: 'Error',
          message: err.message,
        });
      }
    },
    resetState() {
      this.optional.state = '';
    },
    checkUnique(fieldName) {
      this.$refs.form.validateField(fieldName, async (errorMessage) => {
        if (errorMessage) {
          this.$message.error({
            message: errorMessage,
          });
          return false;
        }
        this.verifying[fieldName] = true;
        this.formIcons[fieldName] = this.icons[2];

        let customersWithFieldName = [];
        try {
          customersWithFieldName = await this.searchCustomersByField(fieldName);
        } catch (err) {
          this.$message.error({
            title: 'Error',
            message: 'There was an error while searching for customers',
          });
          console.error(err);
          return false;
        }
        this.formFieldIsUnique[fieldName] = customersWithFieldName.length === 0;
        if (this.formFieldIsUnique[fieldName]) {
          this.verifying[fieldName] = false;
          this.formIcons[fieldName] = this.icons[1];
          return true;
        }

        this.formErrorMessage[fieldName] = `${fieldName} already exists`;
        try {
          if (fieldName === 'email') {
            const customer = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/search`, {
              params: { email: this.form.email },
              headers: {
                Authorization: `Bearer ${this.$keycloak.token}`,
              },
            });
            if (customer.data.length) {
              const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${customer.data[0].locations[0]}`, {
                headers: {
                  Authorization: `Bearer ${this.$keycloak.token}`,
                },
              });
              this.formErrorMessage[fieldName] = `${fieldName} already exists in location ${facility.data.title}`;
            }
          }
        } catch (err) {
          this.$message.error({
            title: 'Error',
            message: 'There was an error while searching for customer location',
          });
          console.error(err);
        }

        this.$message.error({
          title: `${fieldName.uppercase} Error`,
          message: this.formErrorMessage[fieldName],
        });

        this.verifying[fieldName] = false;
        this.formIcons[fieldName] = this.icons[0];
        return false;
      });
    },
    clearFormIcons(fieldName) {
      this.formIcons[fieldName] = '';
      this.formErrorMessage[fieldName] = '';
    },
    generateRandomCode() {
      const code = randomCode();
      this.primaryContact.password = code;
    },
    async searchCustomersByField(fieldName) {
      let response;
      if (fieldName === 'email') {
        response = await axios.get(`${AUTH_API_BASE}/customers`, {
          params: {
            email: this.form.email,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      } else if (fieldName === 'taxId') {
        response = await axios.get(`${CUSTOMER_API_BASE}/customers/v1/search`, {
          params: { taxId: this.form.taxId },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      }

      return response.data;
    },
    next() {
      switch (this.active) {
        case 0:
          return this.$refs.form.validate((valid) => {
            if (valid && this.formFieldIsUnique.email && this.formFieldIsUnique.taxId) {
              this.active += 1;
            }
          });
        case 1:
          return this.$refs.form2.validate((valid) => {
            if (valid) {
              this.active += 1;
            }
          });
        case 2:
          if (!this.primaryContact.password) {
            this.primaryContact.generatedPassword = randomCode();
          }
          this.active += 1;
          break;
        case 3:
          this.active += 1;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.green {
  color: green;
}

.red {
  color: red;
}

.header {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/CreateCustomerV2.vue